import throttle from 'lodash/throttle';
import sortBy from 'lodash/sortBy';

$(() => {
    const reportContent = document.getElementById("report-content");
    if (reportContent === null || reportContent === undefined) return;
    const tocLinksContainer = document.getElementById("toc-links");
    const headerTagsToIncludeInToc = "h1, h2, h3";
    const headerTagsInReportContent = reportContent.querySelectorAll(headerTagsToIncludeInToc);
    const tocBackgroundColor = '#f06c00';
    let tocLinks = [];

    createToc(tocLinks, headerTagsInReportContent, tocLinksContainer);
    makeH3LinksExpandable(tocLinks, tocLinksContainer);
    addLinkHighlighting(headerTagsInReportContent, tocLinks);
    makeTocToggleableForSmallScreens();
    addBackgroundColorToToc(tocLinks, tocBackgroundColor);
});

/**
 * Loop through all header tags in the report, as defined by @const headerTagsToIncludeInToc,
 * and creates and appends an anchor-tag for each header in the toc.
 */
const createToc = (tocLinks, headerTagsInReportContent, tocLinksContainer) => {
    let currentH2Id = '';

    for (let i = 0; i < headerTagsInReportContent.length; i++) {
        let tagId = "header" + i.toString();
        const tocLink = document.createElement("a");
        const tocLinkWrapper = document.createElement('div');
        const currentHeaderTag = headerTagsInReportContent[i];

        // Skip headers with className set, to only include normal headers created through TinyMCE
        if (currentHeaderTag.className !== "") {
            continue;
        }
        tocLink.innerHTML = currentHeaderTag.innerHTML;
        tocLink.className = "report-toc--link";
        tocLinkWrapper.className = 'report-toc--link-wrapper';

        switch (currentHeaderTag.tagName) {
            case "H1": tocLink.className += " report-toc--link--h1"; break;
            case "H2": tocLink.className += " report-toc--link--h2"; currentH2Id = tagId; break;
            case "H3": tocLink.className += " report-toc--link--h3--hidden"; tagId = tagId + ':' + currentH2Id; break;
            default: tocLink.className = "report-toc--link"; break;
        }

        currentHeaderTag.id = tagId;
        tocLink.href = "#" + tagId;
        tocLink.id = 'toc-' + tagId;

        tocLinkWrapper.appendChild(tocLink);
        tocLinks.push(tocLink);
        tocLinksContainer.appendChild(tocLinkWrapper);
    }
}

/**
 * Loop through all links in the TOC. If there are any links to h2-titles which has sub-links to h3-titles, 
 * add a toggleable arrow-icon and onClick event which toggles the corresponding h3-titles in the TOC.
 */
const makeH3LinksExpandable = (tocLinks, tocLinksContainer) => {
    const tocLinksContainerList = [...tocLinksContainer.childNodes];

    for (let i = 0; i < tocLinksContainerList.length; i++) {
        const currentLinkWrapper = tocLinksContainerList[i];
        const currentLink = currentLinkWrapper.firstChild;

        const currentLinkIsH2 = currentLink.className.includes('h2');
        const currentLinkHasSubLinks = tocLinks.some((link) => {
            const reg = new RegExp("\\b" + getIdFromTocId(currentLink.id) + "\\b");
            return ((link.id.search(reg) >= 0) && link.className.includes('h3'));
        });

        // The TOC should hide if any links are clicked on the mobile-version, except if the link expands other sub-links
        if (!(currentLinkHasSubLinks && currentLinkIsH2)) {
            $(currentLink).on('click', () => $("#toc-links").toggle());
        }

        // If the current link is a h2-title, and it has sub-links (belonging h3-titles), add an arrow-icon, and add toggle-functionality
        if (currentLinkIsH2 && currentLinkHasSubLinks) {
            const visibleLinkClassName = 'report-toc--link report-toc--link--h3--visible';
            const hiddenLinkClassName = 'report-toc--link report-toc--link--h3--hidden';
            const downArrowClassName = 'report-toc--expand report-toc--expand--down report-toc--expand--down--desktop';
            const upArrowClassName = 'report-toc--expand report-toc--expand--up report-toc--expand--up--desktop';

            const arrowIcon = document.createElement('span');
            arrowIcon.className = downArrowClassName;
            currentLink.after(arrowIcon);

            $(currentLinkWrapper).on('click', () => {
                tocLinksContainer.childNodes.forEach((link) => {
                    const linkElement = link.firstChild;
                    const reg = new RegExp("\\b" + getIdFromTocId(currentLink.id) + "\\b");
            
                    if (linkElement.className.includes('h3') && (linkElement.id.search(reg) >= 0)) {
                        // Toggle visibility of h3-link
                        linkElement.className = linkElement.className.includes('visible')
                            ? hiddenLinkClassName
                            : visibleLinkClassName;
                    }
                    if (linkElement.className.includes('h2') && linkElement.id.search(reg) >= 0) {
                        // Toggle rotation of arrow-icon
                        arrowIcon.className = arrowIcon.className.includes('down')
                            ? upArrowClassName
                            : downArrowClassName;
                    }
                });
            });
        }
    }
}


/**
 * Create an onScroll event which is throttled by lodash's 'throttle'-package, 
 * at an interval set by @const delayForOnScrollEventInMs. 
 * The function collects all header tags in the report, finds the one which is
 * located closest to the top of the user's viewport, and then highlights the
 * matching link in the toc.
 */
const addLinkHighlighting = (headerTagsInReportContent, tocLinks) => {
    const delayForOnScrollEventInMs = 300;

    $(window).on('scroll', throttle(() => {
        const headerTagsArray = Array.from(headerTagsInReportContent);

        const headerTagClosestToTopOfViewport = sortBy(headerTagsArray, (tag) =>
            Math.abs(tag.getBoundingClientRect().top - 0))[0];

        let chapterLinkToHighlight = tocLinks.find(link =>
            link.href.split('/').slice(-1)[0].substring(1) === headerTagClosestToTopOfViewport.id);

        if (chapterLinkToHighlight) {
            // If a toc-link which is hidden should be highlighted, highlight it's parent toc-link instead.
            if (chapterLinkToHighlight.className.includes('hidden')) {
                chapterLinkToHighlight = tocLinks.find((link) => chapterLinkToHighlight.id.includes(getIdFromTocId(link.id)));
            }

            tocLinks.forEach(link => link.style = "");
            chapterLinkToHighlight.style = "color: #f06c00;";
        }
    }, delayForOnScrollEventInMs))
}

/**
 * Creates an onClick event for the toc container which is shown for 
 * 'md' and lower media sizes. Toggles the toc list.
 */
const makeTocToggleableForSmallScreens = () => {
    $("#report-toc--title-container").on('click', () => {
        $("#toc-links").toggle();
    });
}

const addBackgroundColorToToc = (tocLinks, colorHex) => {
    tocLinks[0].style = `color: ${colorHex};`;
}

/**
 * The links in the TOC has ids which corresponds to the ids of the titles in the report.
 * To differentiate them, the links in the TOC follows the convention: 'toc-{id}'.
 * This utility function simply extracts the id-part, which is used for comparrisons.
 */
const getIdFromTocId = (id) => id.split('-').slice(-1)[0];
